export default {
    "status": "ok",
    "message-type": "work",
    "message-version": "1.0.0",
    "message": {
        "indexed": {
            "date-parts": [
                [
                    2018,
                    2,
                    5
                ]
            ],
            "date-time": "2018-02-05T15:43:35Z",
            "timestamp": 1517845415442
        },
        "reference-count": 16,
        "publisher": "American Chemical Society (ACS)",
        "issue": "12",
        "content-domain": {
            "domain": [],
            "crossmark-restriction": false
        },
        "short-container-title": [
            "Nat Chem"
        ],
        "published-print": {
            "date-parts": [
                [
                    2005,
                    6
                ]
            ]
        },
        "DOI": "10.1021/ol050769m",
        "type": "journal-article",
        "created": {
            "date-parts": [
                [
                    2005,
                    6,
                    2
                ]
            ],
            "date-time": "2005-06-02T04:48:28Z",
            "timestamp": 1117687708000
        },
        "page": "249-251",
        "source": "Crossref",
        "is-referenced-by-count": 20,
        "title": [
            "Important looong title for you"
        ],
        "prefix": "10.1021",
        "volume": "7",
        "author": [
            {
                "given": "Bai",
                "family": "Li",
                "affiliation": []
            },
            {
                "given": "Fu-Zi",
                "family": "Kong",
                "affiliation": []
            },
            {
                "given": "Stephen W.",
                "family": "Hawking",
                "affiliation": []
            }
        ],
        "member": "316",
        "container-title": [
            "Nature Chemistry"
        ],
        "original-title": [],
        "link": [
            {
                "URL": "http://pubs.acs.org/doi/pdf/10.1021/ol050769m",
                "content-type": "unspecified",
                "content-version": "vor",
                "intended-application": "similarity-checking"
            }
        ],
        "deposited": {
            "date-parts": [
                [
                    2017,
                    6,
                    16
                ]
            ],
            "date-time": "2017-06-16T19:53:31Z",
            "timestamp": 1497642811000
        },
        "score": 1,
        "subtitle": [],
        "short-title": [],
        "issued": {
            "date-parts": [
                [
                    2018,
                    6
                ]
            ]
        },
        "references-count": 16,
        "alternative-id": [
            "10.1021/ol050769m"
        ],
        "URL": "http://dx.doi.org/10.1021/ol050769m",
        "relation": {},
        "ISSN": [
            "1523-7060",
            "1523-7052"
        ],
        "issn-type": [
            {
                "value": "1523-7060",
                "type": "print"
            },
            {
                "value": "1523-7052",
                "type": "electronic"
            }
        ],
        "subject": [
            "Physical and Theoretical Chemistry",
            "Organic Chemistry",
            "Biochemistry"
        ]
    }
}


// WEBPACK FOOTER //
// ./src/constants/doiResponse.js